module.exports = __webpack_public_path__ + "static/media/cm.cc7ebba7.png";